import { useEffect, useState } from "react"
import { SettingsGroup } from "../../../Modules/General"
import FilesModule from "../../../Modules/FilesModule"
import VariableModule from "../../../Modules/VariableModule"


import * as Basic from "../../../Modules/BasicFields"

const theSelectorVariables = [
    {name:'Control',key:'control',type:'R'},
]

const filesList = [
    {name:'Option 1', key:'option_1'},
    {name:'Option 2', key:'option_2'},
    {name:'Option 3', key:'option_3'},
]

export default function TheSelector( props )
{
    const dynoCfg = props.dynoCfg 
    const setDynoCfg = props.setDynoCfg

    const reset = props.reset

    const [ hashtag, setHashtag ] = useState(null)
    const [ hashtagRate, setHashtagRate ] = useState(null)
    const [ variables, setVariables ] = useState(null)
    const [ files, setFiles ] = useState(null)

    const requiredData = [
        hashtag,
        hashtagRate,
        variables,
        files,
    ]

    const cfgName = "influencer_the_selector_cfg"

    const reload = () => {
        let properties = dynoCfg.properties
        let cfg = properties[cfgName] || {}

        setHashtag( cfg.hashtag || "")
        setHashtagRate( cfg.voting_rate || "one_per_user")
        setVariables(cfg.variables || {} )
        setFiles(cfg.files || {} )
    }

    useEffect( () => {
        reload()
    },[])

    useEffect( () => {

        if( requiredData.includes(null) )
        {
            return
        }
        
        let data = {}
        data.hashtag = hashtag
        data.hashtag_rate = hashtagRate 
        data.variables = variables 
        data.files = files

        let cfg = structuredClone(dynoCfg)
        cfg.properties[cfgName] = data
        setDynoCfg(cfg)
    },[ hashtag, hashtagRate, variables, files ])

    if( requiredData.includes(null) )
    {
        return <></>
    }

    return (
        <>
            <SettingsGroup name="Behaviour"> 
                <Basic.StringInput name="Hashtag" value={hashtag} setValue={setHashtag} />
                <Basic.SelectInput name="Frequency per viewer" value={hashtagRate} setValue={setHashtagRate} 
                                   options={[
                                        { label: "One time only", value: "one_per_user" },
                                        { label: "Once every 10 seconds", value: "one_every_10_seconds" },
                                        { label: "Once every minute", value: "one_every_minute" },
                                        { label: "Unlimited", value: "unlimited" },
                                   ]}
                />
            </SettingsGroup> 
            <VariableModule variables={variables} 
                            setVariables={setVariables} 
                            variableList={theSelectorVariables} 
                            reset={reset}
            />
            <FilesModule files={files} 
                         setFiles={setFiles}
                         filesList={filesList}
                         reset={reset}
            />

        </>
    )
}
